export const isUsernameValid = (text) => /^[a-zA-Z0-9]*$/.test(text);